import { Typography, Box } from '@mui/material'
import { useState } from 'react'
import LockerListTable from './LockerMangTable';
import { useCrudForm } from '../../api/useCrudForm';
import { endpoints } from '../../api/endpoints';
import AddEditLockerModal from './AddNewLockerModal';

const LockerManagement = () => {

    const [open, setOpen] = useState(false)

    const [selectedItem, setSelectedItem] = useState<any | null>()
    const [lockerList, setLockerList] = useState<any | null>()
    const [lockerStatusList, setLockerStatusList] = useState<any | null>()
    const [lockerTypeList, setLockerTypeList] = useState<any | null>()
    const [lockerLocationList, setLockerLocationList] = useState<any | null>()
    const [loading, setLoading] = useState<boolean>(false);
    const [buttonLoading, setButtonLoading] = useState<boolean>(false);
    const [skip, setSkip] = useState(0)
    const [count, setCount] = useState<any>(0);
    const [take, setTake] = useState(10)
    const [showApproved, setShowApproved] = useState<string>('true');

    const { get } = useCrudForm();

    const refetchData = ({ lockerNo, lockerType, lockerLocation, lockerStatus, isMainTable }: { lockerNo?: any, lockerType?: any, lockerLocation?: any, lockerStatus?: any, isMainTable?: any }) => {
        setLoading(true)
        get({
            endpoints: endpoints.locker.list({ lockerNo, skip: skip * take, take, lockerType, lockerLocation, lockerStatus, isMainTable }),
            onSuccess: (data: any) => {
                setLockerList(data.data.list)
                setCount(data.data.count)
                setLoading(false)
                setButtonLoading(false)
            },
            onError: (error: any) => {
                console.log(error)
                setLoading(false)
                setButtonLoading(false)
            }
        })
    }

    return (
        <>
            <Typography variant="h5" component="h5" mb={1} fontWeight={600}>Locker Management</Typography>
            <Box sx={{ width: "100%", padding: "24px 12px", background: "white", borderRadius: "5px" }} my={2}>
                <LockerListTable refetchData={refetchData} loading={loading} setLoading={setLoading} buttonLoading={buttonLoading} setButtonLoading={setButtonLoading} skip={skip} take={take} setTake={setTake} setSkip={setSkip} count={count} setOpen={setOpen} setSelectedItem={setSelectedItem} rows={lockerList} lockerStatusList={lockerStatusList} setLockerStatusList={setLockerStatusList} lockerTypeList={lockerTypeList} setLockerTypeList={setLockerTypeList} lockerLocationList={lockerLocationList} setLockerLocationList={setLockerLocationList} showApproved={showApproved} setShowApproved={setShowApproved} />
            </Box>
            <AddEditLockerModal refetchData={refetchData} open={open} setOpen={setOpen} selectedItem={selectedItem} setSelectedItem={setSelectedItem} showApproved={showApproved} setShowApproved={setShowApproved} setSkip={setSkip} setTake={setTake} />
        </>
    )
}

export default LockerManagement
